import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Subject, Observable, Subscription } from 'rxjs';
import { map, switchMap, concatMap, debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { MessageService } from 'primeng/api';

import { GetglobalsettingsService } from '../../services/getglobalsettings.service'
import { CliListEntry} from '../../shared/cli-list-entry';
import { RestApiService } from '../../services/rest-api.service';
import { ClientApiService } from '../../services/client-api.service';

/**
 * Modal dialog for searching and selecting a client organisation.
 *
 * Data-flow: user types into the search field → `onSearch` / `onKeyPress`
 * push the string onto `searchStr$` → debounced 300 ms → `distinctUntilChanged`
 * skips duplicate values → `filter` requires at least 3 characters →
 * `switchMap(getClientSimpleSearch)` cancels any in-flight call and fetches
 * fresh results → `companies` array is populated in the result table.
 *
 * On confirm, `selectedIds` emits `{ CLIID, PERSID, CASTCATID }` from the
 * selected row.  `displayChange` emits `false` on hide for two-way
 * `[(display)]` binding.
 */
@Component({
  selector: 'app-clients-search',
  templateUrl: './clients-search.component.html',
  styleUrls: ['./clients-search.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ClientsSearchComponent implements OnInit, OnChanges, OnDestroy {

  private clientQuery: Subscription;
  private cliMainQuery: Subscription;

  displayCS: boolean = false;

  something: string = '';
  private searchStr$ = new Subject<string>();

  companies: any[] = [];

  selection: any;

  rows: number = 10;

  /** Dialog header text. */
  @Input()
  header: string = "Поиск организации";

  modal: boolean = true;
  loading: boolean;

  /** Controls dialog visibility; supports two-way binding via `displayChange`. */
  @Input()
  display: boolean = false;

  /** Emits `{ CLIID, PERSID, CASTCATID }` for the confirmed selection. */
  @Output()
  public selectedIds: EventEmitter<{ 'CLIID': number, 'PERSID': number, 'CASTCATID': number }> = new EventEmitter();

  /** Emits `false` on dialog hide to support two-way `[(display)]` binding. */
  @Output() displayChange = new EventEmitter();

  public get thereIsSelection(): boolean { return this.selection ? true : false; }

  constructor(
    private cliApi: ClientApiService,
    private restapi: RestApiService,
    private messageService: MessageService) { }

  /** Unsubscribes `clientQuery` and `cliMainQuery` subscriptions. */
  ngOnDestroy(): void {
    if (this.clientQuery) { this.clientQuery.unsubscribe(); }
    if (this.cliMainQuery) { this.cliMainQuery.unsubscribe(); }
  }

  /** Sets up the debounced `searchStr$` → `getClientSimpleSearch` pipeline. */
  ngOnInit(): void {
    this.clientQuery =
      this.searchStr$.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter((str: string) => str.length > 2),
        switchMap((str: string) => {
          console.log('*** ClientsSearchComponent in createProductSubscription: pgn=(' + str + ')');
          this.loading = true;

          return this.cliApi.getClientSimpleSearch(str);
        })
      )
        .subscribe((data) => {
          console.log('*** ClientsSearchComponent onSearch subscribe: ');
          this.companies = data;
          this.loading = false;
        });
}

  /** Reacts to `display` changes — body is currently a no-op. */
  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** ClientsSearchComponent ngOnChanges');
    for (let propName in changes) {
      let change = changes[propName];
      console.log('*** ClientsSearchComponent ngOnChanges (actual): ' + propName + ' ' + JSON.stringify(change.currentValue));
      //console.log('*** ClientsSearchComponent ngOnChanges (was):    ' + propName + ' ' + JSON.stringify(change.previousValue));

      switch (propName) {
        case 'display':
          if (change.currentValue) {

          }
          break;
      }
    }
  }

  /** Pushes the current search string onto `searchStr$` when the dialog opens. */
  onShowDialog() {
    console.log('*** ClientsSearchComponent onShow: ');
    this.searchStr$.next(this.something);
  }

  /** Emits `false` via `displayChange` to close the dialog. */
  onHideDialog() {
    console.log('*** ClientsSearchComponent onHide');
    this.displayChange.emit(false);
  }

  /** Emits `{ CLIID, PERSID, CASTCATID }` from the selected row and closes the dialog. */
  onConfirm(text: string) {
    console.log('*** ClientsSearchComponent onConfirm: ' + text);
    this.selectedIds.emit({ 'CLIID': this.selection.CLIID, 'PERSID': this.selection.PERSID, 'CASTCATID': this.selection.CASTCATID });
    this.display = false;
  }

  /** Search button click handler — pushes `something` onto `searchStr$`. */
  onSearch(event) {
    console.log('*** ClientsSearchComponent onSearch: ' + JSON.stringify(event));
    this.searchStr$.next(this.something);
  }

  /** Keyup handler — pushes `something` onto `searchStr$` on every keystroke. */
  onKeyPress(event) {
    console.log('*** ClientsSearchComponent onKeyPress: ' + JSON.stringify(event));
    this.searchStr$.next(this.something);
  }

}
